const initialState = {
  xatlovPoints: null,
  allHouse: true,
  turarNoturarData: null,
  turarNoturarLine: null,
  Line: null
}

const XatlovP = (state = initialState, action) => {
  switch (action.type) {
    case "SET_XATLOVPOINTS":
      return { ...state, xatlovPoints: action.val }
    case "SET_ALLHOUSE":
      return { ...state, allHouse: action.val }
    case "SET_TURARNOTURARDATA":
      return { ...state, turarNoturarData: action.val }
    case "SET_TURARNOTURARLINE":
      return { ...state, turarNoturarLine: action.val }
    case "SET_LINE":
      return { ...state, Line: action.val }
    default:
      return state
  }
}
export default XatlovP
